import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=255eb12a&scoped=true&"
import script from "./RoleAdd.vue?vue&type=script&lang=ts&"
export * from "./RoleAdd.vue?vue&type=script&lang=ts&"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=255eb12a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255eb12a",
  null
  
)

export default component.exports